import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Edit16, TrashCan16 } from '@carbon/icons-vue';

// The row menu of the settings lists (R2-9-4: the kit's ⋮ RowMenu with "Edit" and "Delete", in place of the two
// icon buttons). `rowMenuItems(['edit', 'delete'])` gives the items; `rowMenuLabel(name)` names the button.
export function useSettingsRowMenu() {
  const { t } = useI18n();
  const all = computed(() => ({
    edit: { label: t('SETTINGS_TABLE.EDIT'), value: 'edit', icon: Edit16 },
    delete: {
      label: t('SETTINGS_TABLE.DELETE'),
      value: 'delete',
      icon: TrashCan16,
      destructive: true,
    },
  }));
  const rowMenuItems = (actions = ['edit', 'delete']) =>
    actions.map(action => all.value[action]);
  const rowMenuLabel = name => t('SETTINGS_TABLE.ROW_ACTIONS', { name });
  return { rowMenuItems, rowMenuLabel };
}
